import { render, staticRenderFns } from "./setores-risco.vue?vue&type=template&id=8e31ce14&"
import script from "./setores-risco.vue?vue&type=script&lang=js&"
export * from "./setores-risco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports